import React, { useContext, useEffect, useState } from 'react';
import { VehicleContext } from '../../Context/VehicleContext'; // Adjust path as needed
import { getImages } from '../../Common/const'; // Adjust path as needed

// 1. Import DnD Kit
import {
    DndContext,
    closestCenter,
    KeyboardSensor,
    PointerSensor,
    useSensor,
    useSensors,
} from '@dnd-kit/core';
import {
    arrayMove,
    SortableContext,
    sortableKeyboardCoordinates,
    verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import { AdminSortableItem } from './AdminSortableItem';

// 2. Import the row component created above

const FeaturedVehicles = () => {
    const { getVehicleData, vehicleData, priceFormatter, inventoryManage} = useContext(VehicleContext);

    // --- State Management ---
    const [sortedVehicles, setSortedVehicles] = useState([]);
    const [inventoryManageData, setInventoryManageData] = useState({});
    //console.log("inventoryManageData", inventoryManageData)
    useEffect(() => {
        getVehicleData();
    }, []);

    // Initial Data Load
    useEffect(() => {
        if (vehicleData) {
            setSortedVehicles(vehicleData.sort((a,b) => a.make.localeCompare(b.make)));

            const inventory_manage_data = vehicleData.reduce((acc, item) => {
                acc[item.vin] = item.inventory_manage;
                return acc;
            }, {});
            setInventoryManageData(inventory_manage_data);
        }
    }, [vehicleData]);

    // --- Helper Functions ---
    const updateInventoryManage = (e, vin, field) => {
        const value = e.target.type === "checkbox" ? e.target.checked : e.target.value;

        // If the field is "hide" ➜ No limit, no conditions
        if (field === "hide") {
            setInventoryManageData(prev => ({
                ...prev,
                [vin]: { ...prev[vin], hide: value }
            }));
            inventoryManage({...inventoryManageData[vin],[field]:value,["vin"]:vin});
            return; // Exit here — no other logic needed
        }

        // If the field is "pending" ➜ No limit, no conditions
        if (field === "pending") {
            setInventoryManageData(prev => ({
                ...prev,
                [vin]: { ...prev[vin], pending: value }
            }));
            inventoryManage({...inventoryManageData[vin],[field]:value,["vin"]:vin});
            return; // Exit here — no other logic needed
        }
        // For HOME and SRP only (with max 6 selection limit)
        const current = inventoryManageData[vin] || {};

        const selectedCount = Object.entries(inventoryManageData)
            .filter(([key, row]) => key !== vin && (row[field]))
            .length;

        const isSelecting = value === true;
        const isRowAlreadySelected = current.home || current.srp;

        if (isSelecting && selectedCount >= 6 && !isRowAlreadySelected) {
            alert("You can select a maximum of 6 vehicles.");
            return;
        }

        // Update for home/srp
        setInventoryManageData(prev => ({
            ...prev,
            [vin]: { ...prev[vin], [field]: value }
        }));

        inventoryManage({...inventoryManageData[vin],[field]:value,["vin"]:vin})
    };

    const selectedRowsCount = Object.values(inventoryManageData)
        .filter(row => row?.home || row?.srp)
        .length;

    // --- Drag and Drop Logic ---
    const sensors = useSensors(
        useSensor(PointerSensor),
        useSensor(KeyboardSensor, {
            coordinateGetter: sortableKeyboardCoordinates,
        })
    );

    const handleDragEnd = (event) => {
        const { active, over } = event;

        if (active.id !== over.id) {
            setSortedVehicles((items) => {
                const oldIndex = items.findIndex((item) => item.vin === active.id);
                const newIndex = items.findIndex((item) => item.vin === over.id);
                return arrayMove(items, oldIndex, newIndex);
            });
        }
    };

    return (
        <div className='container'>
            <div className='admin-fv-box'>
                <div className='md-title fw-700 text-uppercase mb-5'>SELECT FEATURED VEHICLES</div>

                <div className='d-flex align-items-center mb-2'>
                    <div className='xs-title font-1-2em avenir-next w-53'>
                        Select up to 6 vehicles
                        <img className="ms-3" src={getImages('admin-info-icon.svg')} alt="info" />
                    </div>
                    <div className='xs-title font-14 avenir-next w-47'>{selectedRowsCount} of 6 Selected</div>
                </div>

                {/* DnD Context Wrapper */}
                <DndContext
                    sensors={sensors}
                    collisionDetection={closestCenter}
                    onDragEnd={handleDragEnd}
                >
                    <table className='w-100 custom-table'>
                        <thead>
                            <tr>
                                <th style={{ width: '30%' }}>Vehicle</th>
                                <th style={{ width: '5%' }} className='text-center'>Last 4</th>
                                <th style={{ width: '5%' }} className='text-center'>Location</th>
                                <th style={{ width: '13%' }} className='text-center'>Price</th>
                                {/* <th style={{ width: '10%' }} className='text-center'>Stock #</th> */}
                                <th style={{ width: '10%' }} className='text-center'>Home</th>
                                <th style={{ width: '10%' }} className='text-center'>SRP</th>
                                <th style={{ width: '10%' }} className='text-center'>Hide</th>
                                <th style={{ width: '10%' }} className='text-center'>Pending</th>
                                <th style={{ width: '7%' }} className='text-end'>&nbsp;</th>
                            </tr>
                        </thead>
                    </table>
                    {/* Pass list of IDs to Sortable Context */}
                    <SortableContext
                        items={sortedVehicles.map(v => v.vin)}
                        strategy={verticalListSortingStrategy}
                    >
                        {sortedVehicles.filter(Boolean).map((item) => (
                                    <AdminSortableItem
                                        key={item.vin}
                                        item={item}
                                        inventoryManageData={inventoryManageData}
                                        updateInventoryManage={updateInventoryManage}
                                        priceFormatter={priceFormatter}
                                        getImages={getImages}
                                    />
                        ))}
                    </SortableContext>
                </DndContext>
            </div>
        </div>
    );
}

export default FeaturedVehicles;